import { configRequest as request, requestRecaptcha } from '@/config/ConfigRequest';
import ENDPOINT from '@/config/endpoint';
import { getToken } from '@/utils/common';

const cookieTempTokenKey = process.env.VUE_APP_COOKIE_TEMPORARY_TOKEN_KEY || 'tmp_token';

function createAccount(data, recaptchaToken) {
  return requestRecaptcha({
    url: `${ENDPOINT.REGISTER}/create`,
    method: 'post',
    data,
  }, recaptchaToken);
}

function confirmPassword(data) {
  const token = getToken(cookieTempTokenKey);
  return request({
    url: `${ENDPOINT.REGISTER}/confirm`,
    method: 'post',
    data,
  }, token);
}

export {
  createAccount,
  confirmPassword,
};
